"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.approvePaymentDetails = approvePaymentDetails;
exports.checkExpert = checkExpert;
exports.checkSherlockList = checkSherlockList;
exports.checkSherlockOpinion = checkSherlockOpinion;
exports.confirmPaymentDetails = confirmPaymentDetails;
exports.create = create;
exports.createBasicProfile = createBasicProfile;
exports["default"] = void 0;
exports.deleteAttachment = deleteAttachment;
exports.duplicateExpert = duplicateExpert;
exports.exportPinnedExperts = exportPinnedExperts;
exports.forgotPassword = forgotPassword;
exports.getAttachments = getAttachments;
exports.getContactInfo = getContactInfo;
exports.getContactTypes = getContactTypes;
exports.getEplStatusCount = getEplStatusCount;
exports.getExpertHonorariumHistory = getExpertHonorariumHistory;
exports.getExpertNames = getExpertNames;
exports.getExpertProjects = getExpertProjects;
exports.getExpertsForProject = getExpertsForProject;
exports.getInterviewCount = getInterviewCount;
exports.getInterviewCounts = getInterviewCounts;
exports.getLastActive = getLastActive;
exports.getManyById = getManyById;
exports.getOne = getOne;
exports.getOneById = getOneById;
exports.getOtherServices = getOtherServices;
exports.getPDLExpert = getPDLExpert;
exports.getPDLExperts = getPDLExperts;
exports.getPaymentDetails = getPaymentDetails;
exports.getPositions = getPositions;
exports.getProfileUpdateBlock = getProfileUpdateBlock;
exports.getProjectFeedbacks = getProjectFeedbacks;
exports.getRejectionReasons = getRejectionReasons;
exports.getReplyStatusCount = getReplyStatusCount;
exports.getUnsubscribeContacts = getUnsubscribeContacts;
exports.rejectPaymentDetails = rejectPaymentDetails;
exports.remove = remove;
exports.removeCvSource = removeCvSource;
exports.savePaymentDetails = savePaymentDetails;
exports.searchExperts = searchExperts;
exports.sendAnonymousActionEmail = sendAnonymousActionEmail;
exports.sendCompliance = sendCompliance;
exports.setComplianceSigned = setComplianceSigned;
exports.setStaticComplianceDeclined = setStaticComplianceDeclined;
exports.setStaticComplianceSigned = setStaticComplianceSigned;
exports.toggleStatus = toggleStatus;
exports.typeahead = typeahead;
exports.unsubscribe = unsubscribe;
exports.update = update;
exports.updateContactInfo = updateContactInfo;
exports.updateLinkedinVanityName = updateLinkedinVanityName;
exports.updateV2 = updateV2;

var _api = _interopRequireWildcard(require("./api"));

var _lib = require("./lib");

var _defaultsDeep = _interopRequireDefault(require("lodash/defaultsDeep"));

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var base = '/api/expert'; // Make sure to remove faulty ID values (like null or '') otherwise backend validation will fail
// E.g. {id: null, email: 'john@smith.com'} => {id: undefined, email: 'john@smith.com'}

function cleanUpObject(object) {
  return _objectSpread(_objectSpread({}, object), {}, {
    id: object.id || undefined
  });
}

function cleanUpSubIndustry(subIndustryObject) {
  return {
    subindustryId: subIndustryObject.id,
    name: subIndustryObject.name
  };
}

function isLinkValid(linkObject) {
  return !!linkObject.professionalLinkUrl;
}

function isPhoneValid(phoneObject) {
  return !!phoneObject.phoneNum && !!phoneObject.phoneTypeId;
}

function cleanupData(rawExpertFormData) {
  var expertFormData = (0, _lib.deepOmit)(rawExpertFormData, ['updatedBy', 'oldNid']);
  expertFormData.expert.newsletter = !!expertFormData.expert.newsletter;
  var subIndustries = expertFormData.expert.subIndustries.map(cleanUpSubIndustry);
  var links = expertFormData.links.filter(isLinkValid).map(cleanUpObject);
  var phones = expertFormData.address.phones.filter(isPhoneValid).map(cleanUpObject);
  var emails = expertFormData.address.emails.map(cleanUpObject);
  var addressData = Object.assign({}, expertFormData.address, {
    phones: phones,
    emails: emails
  });
  var data = Object.assign({}, expertFormData, {
    email: expertFormData.email || null,
    subIndustries: subIndustries,
    links: links,
    address: addressData
  });
  data.expert.subIndustries = expertFormData.subIndustries ? expertFormData.subIndustries : expertFormData.expert.subIndustries;
  data.experiences.forEach(function (e) {
    e.position = e.position.name || e.position;
    e.company = e.company.name || e.company;
  });
  return data;
}

function create(expertFormData) {
  var expertData = cleanupData(expertFormData);
  return _api["default"].post(base, expertData).then(_api.extractData)["catch"](_api.errorHandler);
}

function createBasicProfile(expertId, profileFormData) {
  return _api["default"].put("/api/expert/".concat(expertId, "/create-basic-profile"), profileFormData);
}

function getOne(expertId, eplId) {
  return _api["default"].get("/api/expert/".concat(expertId), {
    params: {
      eplId: eplId
    }
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getOneById(expertId) {
  return _api["default"].get("/api/expert/".concat(expertId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getManyById(expertIds) {
  return _api["default"].post("/api/expert/many", {
    ids: expertIds
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function update(expertId, expertFormData, oldExpertData) {
  // _original property is used to compare data changes on the backed and avoid data overwrites
  // if two (or more) different users updated expert's data at the same/similar time
  // Note: This works only on the expert endpoint
  var originalExpertData = {
    _original: oldExpertData._original
  };
  var cleansedExpertData = cleanupData(expertFormData);
  var expertData = (0, _defaultsDeep["default"])(Object.assign({
    id: expertId
  }, cleansedExpertData, originalExpertData), oldExpertData);
  return _api["default"].put("".concat(base, "/").concat(expertId), expertData).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateV2(expertId, expertFormData, oldExpertData) {
  var cleansedExpertData = cleanupData(expertFormData);
  var expertData = (0, _defaultsDeep["default"])(Object.assign({
    id: expertId
  }, cleansedExpertData), oldExpertData);
  return _api["default"].put("/api/v2/expert/".concat(expertId), expertData).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateLinkedinVanityName(expertId, linkedinVanityName) {
  return _api["default"].put("".concat(base, "/").concat(expertId, "/linkedin-vanity-name"), {
    linkedinVanityName: linkedinVanityName
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function remove(expertId) {
  return _api["default"]["delete"]("".concat(base, "/").concat(expertId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getPaymentDetails(expertId) {
  return _api["default"].get("/api/expert-payment-detail/".concat(expertId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getRejectionReasons() {
  return _api["default"].get('/api/epd-rejection-reason').then(_api.extractData)["catch"](_api.errorHandler);
}

function savePaymentDetails(expertId, paymentData) {
  return _api["default"].put("/api/expert-payment-detail/".concat(expertId), paymentData).then(_api.extractData)["catch"](_api.errorHandler);
}

function confirmPaymentDetails(id) {
  return _api["default"].put('/api/expert-payment-detail/' + id + '/confirm').then(_api.extractData)["catch"](_api.errorHandler);
}

function approvePaymentDetails(id) {
  return _api["default"].put('/api/expert-payment-detail/' + id + '/approve').then(_api.extractData)["catch"](_api.errorHandler);
}

function rejectPaymentDetails(payload) {
  var expertId = payload.expertId;
  return _api["default"].put('/api/expert-payment-detail/' + expertId + '/unconfirmed', payload).then(_api.extractData)["catch"](_api.errorHandler);
}

function getPositions(expertId, eplId) {
  var data = eplId ? {
    eplId: eplId
  } : undefined;
  return _api["default"].get("/api/expert/".concat(expertId, "/positions"), {
    params: _objectSpread({}, data)
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function toggleStatus(expertId, payload) {
  return _api["default"].put("/api/expert/".concat(expertId, "/expert-status"), payload).then(_api.extractData)["catch"](_api.errorHandler);
}

function setComplianceSigned(expertId, payload) {
  return _api["default"].put("/api/expert/".concat(expertId, "/set-compliance-signed"), payload).then(_api.extractData)["catch"](_api.errorHandler);
}

function setStaticComplianceSigned(expertId, referrerID) {
  return _api["default"].put("/api/expert/".concat(expertId, "/set-static-compliance-signed"), {
    referrerID: referrerID
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function unsubscribe(payload) {
  var uuid = payload.uuid;
  return _api["default"].post("/api/expert/unsubscribe/".concat(uuid), payload).then(_api.extractData)["catch"](_api.errorHandler);
}

function getContactTypes(uuid) {
  var url = '/api/expert/contact-types';

  if (uuid) {
    url += "/".concat(uuid);
  }

  return _api["default"].get(url, {}).then(_api.extractData)["catch"](_api.errorHandler);
}

function getUnsubscribeContacts(uuid) {
  var url = '/api/expert/unsubscribe/contacts';

  if (uuid) {
    url += "/".concat(uuid);
  }

  return _api["default"].get(url, {}).then(_api.extractData)["catch"](_api.errorHandler);
}

function setStaticComplianceDeclined(expertId) {
  return _api["default"].put("/api/expert/".concat(expertId, "/set-static-compliance-declined"), {}).then(_api.extractData)["catch"](_api.errorHandler);
}

function sendAnonymousActionEmail(payload) {
  return _api["default"].put("/api/expert/send-anonymous-action-email", payload).then(_api.extractData)["catch"](_api.errorHandler);
}

function getLastActive(expertId) {
  return _api["default"].get("/api/expert/".concat(expertId, "/last-active")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getInterviewCount(expertId) {
  return _api["default"].get("/api/expert/interview-count?expertId=".concat(expertId)).then(_api.extractData).then(function (data) {
    return data[expertId];
  })["catch"](_api.errorHandler);
}

function getInterviewCounts(expertIds) {
  var queryParams = _queryString["default"].stringify({
    expertId: expertIds
  });

  return _api["default"].get("/api/expert/interview-count?".concat(queryParams)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getAttachments(expertId) {
  return _api["default"].get("/api/expert/".concat(expertId, "/attachments")).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteAttachment(expertId) {
  return _api["default"]["delete"]("/api/expert/attachments/".concat(expertId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function sendCompliance(data) {
  return _api["default"].post('/api/expert/compliance/send', data).then(_api.extractData)["catch"](_api.errorHandler);
}

function typeahead(query) {
  var encodedQuery = encodeURIComponent(query);
  var limit = 40;
  return _api["default"].get("/api/expert/typeahead-search?q=".concat(encodedQuery, "&limit=").concat(limit)).then(_api.extractData)["catch"](_api.errorHandler);
}

function duplicateExpert(fullName) {
  var encodedQuery = encodeURIComponent(fullName);
  return _api["default"].get("/api/expert/find-duplicates?fullname=".concat(encodedQuery)).then(_api.extractData)["catch"](_api.errorHandler);
}

function checkExpert(params) {
  return _api["default"].post("/api/expert/find-duplicates", params).then(_api.extractData)["catch"](_api.errorHandler);
}

function forgotPassword(userEmail) {
  return _api["default"].post('/api/expert/forgot-password', {
    email: userEmail
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getExpertProjects(expertId, limit, offset) {
  var eplStatuses = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var replyStatuses = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var elasticHighlight = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var includeScreeningInformation = arguments.length > 6 ? arguments[6] : undefined;
  return _api["default"].post("/api/expert/projects/".concat(expertId), {
    limit: limit,
    offset: offset,
    eplStatuses: eplStatuses,
    replyStatuses: replyStatuses,
    isFrontend: true,
    // this flag presents is this api is called from frontend project
    elasticHighlight: elasticHighlight,
    includeScreeningInformation: includeScreeningInformation
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getExpertHonorariumHistory(expertId, limit, offset) {
  return _api["default"].post("/api/expert/honorarium-history/".concat(expertId), {
    limit: limit,
    offset: offset
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getOtherServices(expertId, limit, offset) {
  return _api["default"].get("/api/expert/".concat(expertId, "/other-services?limit=").concat(limit, "&offset=").concat(offset)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getProjectFeedbacks(eplId, expertId) {
  return _api["default"].get("/api/expert-project-feedback/by-epl?eplId=".concat(eplId, "&expertId=").concat(expertId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function searchExperts(data) {
  // COMMENT TO FORCE COMPILE
  return _api["default"].post(process.env.REACT_APP_SEARCH_SERVICE_URL + '/expert', data).then(_api.extractData)["catch"](_api.errorHandler);
}

function getPDLExpert(id) {
  return _api["default"].post(process.env.REACT_APP_SEARCH_SERVICE_URL + '/pdl', {
    id: id
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getPDLExperts(ids) {
  return _api["default"].post(process.env.REACT_APP_SEARCH_SERVICE_URL + '/pdl/many', {
    ids: ids
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getContactInfo(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      companies = _ref.companies;
  return _api["default"].post("".concat(base, "/contact-info"), {
    firstName: firstName,
    lastName: lastName,
    companies: companies
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateContactInfo(expertId, data) {
  return _api["default"].put("".concat(base, "/").concat(expertId, "/contact-info"), data).then(_api.extractData)["catch"](_api.errorHandler);
}

function removeCvSource(cvSourceId, cvId) {
  return _api["default"]["delete"]("/api/cv-source/".concat(cvSourceId), {
    data: {
      cvId: cvId
    }
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getEplStatusCount(_x) {
  return _getEplStatusCount.apply(this, arguments);
}

function _getEplStatusCount() {
  _getEplStatusCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(expertId) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _api["default"].get("".concat(base, "/projects/").concat(expertId, "/epl-status-count")).then(_api.extractData)["catch"](_api.errorHandler));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getEplStatusCount.apply(this, arguments);
}

function getReplyStatusCount(_x2) {
  return _getReplyStatusCount.apply(this, arguments);
}

function _getReplyStatusCount() {
  _getReplyStatusCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(expertId) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _api["default"].get("".concat(base, "/projects/").concat(expertId, "/reply-status-count")).then(_api.extractData)["catch"](_api.errorHandler));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getReplyStatusCount.apply(this, arguments);
}

function exportPinnedExperts(_x3) {
  return _exportPinnedExperts.apply(this, arguments);
}

function _exportPinnedExperts() {
  _exportPinnedExperts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(expertIds) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _api["default"].post("".concat(base, "/experts-export"), {
              expertIds: expertIds
            }).then(_api.extractData)["catch"](_api.errorHandler));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _exportPinnedExperts.apply(this, arguments);
}

function getProfileUpdateBlock(_x4) {
  return _getProfileUpdateBlock.apply(this, arguments);
}

function _getProfileUpdateBlock() {
  _getProfileUpdateBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(expertId) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _api["default"].get("".concat(base, "/").concat(expertId, "/profile-update-block")).then(_api.extractData)["catch"](_api.errorHandler));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getProfileUpdateBlock.apply(this, arguments);
}

function checkSherlockOpinion(expertId) {
  return _api["default"].get("".concat(base, "/").concat(expertId, "/sherlock")).then(_api.extractData)["catch"](_api.errorHandler);
}

function checkSherlockList(experts) {
  return _api["default"].post("".concat(base, "/sherlock-list"), {
    results: experts
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getExpertsForProject(_x5) {
  return _getExpertsForProject.apply(this, arguments);
}

function _getExpertsForProject() {
  _getExpertsForProject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(expertIds) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", _api["default"].post("".concat(base, "/for-project"), {
              expertIds: expertIds
            }).then(_api.extractData)["catch"](_api.errorHandler));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getExpertsForProject.apply(this, arguments);
}

function getExpertNames(_x6) {
  return _getExpertNames.apply(this, arguments);
}

function _getExpertNames() {
  _getExpertNames = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(expertIds) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", _api["default"].get("".concat(base, "/names?ids=").concat(JSON.stringify(expertIds))).then(_api.extractData)["catch"](_api.errorHandler));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getExpertNames.apply(this, arguments);
}

var api = {
  approvePaymentDetails: approvePaymentDetails,
  confirmPaymentDetails: confirmPaymentDetails,
  create: create,
  createBasicProfile: createBasicProfile,
  deleteAttachment: deleteAttachment,
  duplicateExpert: duplicateExpert,
  exportPinnedExperts: exportPinnedExperts,
  forgotPassword: forgotPassword,
  getExpertsForProject: getExpertsForProject,
  getAttachments: getAttachments,
  getContactInfo: getContactInfo,
  getEplStatusCount: getEplStatusCount,
  getExpertProjects: getExpertProjects,
  getExpertHonorariumHistory: getExpertHonorariumHistory,
  getExpertNames: getExpertNames,
  getInterviewCount: getInterviewCount,
  getInterviewCounts: getInterviewCounts,
  getLastActive: getLastActive,
  getOne: getOne,
  getOneById: getOneById,
  getManyById: getManyById,
  getOtherServices: getOtherServices,
  getPaymentDetails: getPaymentDetails,
  getPositions: getPositions,
  getProfileUpdateBlock: getProfileUpdateBlock,
  getProjectFeedbacks: getProjectFeedbacks,
  getRejectionReasons: getRejectionReasons,
  getReplyStatusCount: getReplyStatusCount,
  rejectPaymentDetails: rejectPaymentDetails,
  remove: remove,
  removeCvSource: removeCvSource,
  savePaymentDetails: savePaymentDetails,
  searchExperts: searchExperts,
  sendCompliance: sendCompliance,
  setComplianceSigned: setComplianceSigned,
  setStaticComplianceSigned: setStaticComplianceSigned,
  unsubscribe: unsubscribe,
  getContactTypes: getContactTypes,
  setStaticComplianceDeclined: setStaticComplianceDeclined,
  sendAnonymousActionEmail: sendAnonymousActionEmail,
  toggleStatus: toggleStatus,
  typeahead: typeahead,
  update: update,
  updateContactInfo: updateContactInfo,
  updateLinkedinVanityName: updateLinkedinVanityName,
  checkSherlockOpinion: checkSherlockOpinion,
  checkSherlockList: checkSherlockList,
  getPDLExpert: getPDLExpert,
  checkExpert: checkExpert
};
var _default = api;
exports["default"] = _default;